<template>
  <div class="main tabs_main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">员工姓名：</span>
        <el-input
          v-model="realName"
          clearable
          :size="size"
          placeholder="请输入员工姓名"
        ></el-input>
      </div>
      <div class="header_item">
        <span class="header_label">部门：</span>
        <el-select v-model="departId" :size="size" clearable placeholder="请选择部门">
          <el-option
            v-for="item in departmentData"
            :key="item.departId"
            :label="item.departName"
            :value="item.departId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">岗位：</span>
        <el-select v-model="posId" :size="size" clearable placeholder="请选择岗位">
          <el-option
            v-for="item in postData"
            :key="item.posId"
            :label="item.posName"
            :value="item.posId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="header_item">
        <span class="header_label">人员状态：</span>
        <el-select v-model="status" :size="size" clearable placeholder="请选择人员状态">
          <el-option label="在岗" value="1"></el-option>
          <el-option label="已离职" value="2"></el-option>
        </el-select>
      </div>
      <div class="header_item">
        <el-button
          v-if="showButton('search')"
          icon="el-icon-search"
          @click="searchMortgageeInfo(true)"
          >查询</el-button
        >
        <el-button
          class="search_btn"
          v-if="showButton('insert')"
          icon="el-icon-plus"
          @click="propInsert()"
          >新增</el-button
        >
        <el-button
          v-if="showButton('export')"
          icon="el-icon-upload2"
          @click="exportExcel()"
          >导出Excel</el-button
        >
      </div>
    </div>
    <!-- <div class="main_functional">
      <el-button :size="size" icon="el-icon-search" @click="searchMortgageeInfo(true)">查询</el-button>
      <el-button :size="size" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      <el-button :size="size" icon="el-icon-upload2" @click="exportExcel()">导出Excel</el-button>
    </div> -->
    <div class="main_content">
      <el-table v-loading="loading" :data="mortgageeList" height="100%">
        <el-table-column label="序号" width="55" align="center">
          <template #default="scope">
            <span>{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="jobNum" label="工号" align="center"></el-table-column>
        <el-table-column
          prop="realName"
          label="员工姓名"
          align="center"
        ></el-table-column>
        <el-table-column prop="sexStr" label="性别" align="center"></el-table-column>
        <el-table-column
          prop="idNo"
          width="200"
          label="身份证号"
          align="center"
        >
          <template #default="{ row }">
            <div>{{row.idNo.slice(0,3)}}*****{{row.idNo.slice(15)}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone"
          width="150"
          label="手机号码"
          align="center"
        >
          <template #default="{ row }">
            <div>{{row.phone.slice(0,3)}}*****{{row.phone.slice(8)}}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="departName"
          width="150"
          label="部门"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="groupNames"
          width="150"
          label="班组"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="posName"
          width="150"
          label="岗位"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="hasCertStr"
          width="150"
          label="有无作业证书"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="zzmmValue"
          label="政治面貌"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="comeFactoryTime"
          width="200"
          label="进厂时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="leaveFactoryTime"
          width="200"
          label="离岗时间"
          align="center"
        ></el-table-column>
        <el-table-column prop="jg" label="籍贯" align="center"></el-table-column>
        <el-table-column
          prop="employedTime"
          width="200"
          label="入职日期"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="statusStr"
          label="人员状态"
          align="center"
        ></el-table-column>
        <el-table-column label="人脸识别标识" align="center" width="120">
          <template #default="{ row }">
            <div>
              {{ row.photo ? "已上传" : "未上传" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="isLoginStr"
          width="100"
          label="建登录账号"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template #default="{ row }">
            <el-button
              class="table_btn"
              size="mini"
              v-if="showButton('update')"
              @click="propInsertFace(row)"
              >人脸识别</el-button
            >
            <el-button
              class="table_btn"
              size="mini"
              v-if="showButton('update')"
              @click="propUpdate(row)"
              >修改</el-button
            >
            <el-button
              class="delete_btn"
              size="mini"
              v-if="showButton('delete')"
              @click="deleteInfo(row)"
              >删除</el-button
            >
            <el-button
              class="table_btn"
              size="mini"
              v-if="showButton('delete')"
              @click="propDetails(row)"
              >详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增 修改 -->
    <el-dialog
      class="prop_dialog"
      :title="
        asyncTitle === 1 ? '新增员工' : asyncTitle === 2 ? '修改员工信息' : '查看详情信息'
      "
      :visible.sync="asyncMortgagee"
      width="35%"
    >
      <el-form
        ref="form"
        :model="formMortgagee"
        :rules="rulesMortgagee"
        label-width="auto"
        class="rule_form"
      >
        <!-- <el-form-item label="工号：" >  
          <el-input v-model="formMortgagee.number" :size="size" clearable placeholder="请输入工号"></el-input>
        </el-form-item> -->
        <el-form-item label="员工姓名：" prop="realName">
          <el-input
            v-model="formMortgagee.realName"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请输入员工姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别：" prop="sex">
          <el-select
            v-model="formMortgagee.sex"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择性别"
          >
            <el-option label="男" :value="0"></el-option>
            <el-option label="女" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input
            v-model="formMortgagee.phone"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="身份证号：" prop="idNo">
          <el-input
            v-model="formMortgagee.idNo"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <el-form-item label="岗位：" prop="posId">
          <el-select
            v-model="formMortgagee.posId"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择岗位"
          >
            <el-option
              v-for="item in postData"
              :key="item.posId"
              :label="item.posName"
              :value="item.posId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门：" prop="departId">
          <el-select
            v-model="formMortgagee.departId"
            :size="size"
            :disabled="disabled"
            @change="changeDepartment"
            clearable
            placeholder="请选择部门"
          >
            <el-option
              v-for="item in departmentData"
              :key="item.departId"
              :label="item.departName"
              :value="item.departId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班组：">
          <el-select
            v-model="formMortgagee.groups"
            multiple
            :disabled="disabled"
            :size="size"
            clearable
            placeholder="请选择班组"
          >
            <el-option
              v-for="item in teamGroupData"
              :key="item.groupId"
              :label="item.groupName"
              :value="item.groupId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有无作业证书：">
          <el-select
            v-model="formMortgagee.hasCert"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择有无作业证书"
          >
            <el-option label="有" :value="1"></el-option>
            <el-option label="无" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌：" prop="zzmm">
          <el-select
            v-model="formMortgagee.zzmm"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择政治面貌"
          >
            <el-option
              v-for="item in dictionaryData"
              :key="item.dictId"
              :value="item.dictId"
              :label="item.dictName"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="进厂时间：" prop="comeFactoryTime">
          <el-date-picker
            v-model="formMortgagee.comeFactoryTime"
            value-format="yyyy-MM-dd"
            type="date"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择进厂时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="离岗时间：">
          <el-date-picker
            v-model="formMortgagee.leaveFactoryTime"
            value-format="yyyy-MM-dd"
            type="date"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择离岗时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="籍贯：" prop="jg">
          <el-cascader
            v-model="formMortgagee.jg"
            :options="cityData"
            :props="{
              value: 'id',
              label: 'name',
              children: 'childs',
              emitPath: false,
            }"
            placeholder="请选择籍贯"
            clearable
            :disabled="disabled"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item label="入职日期：" prop="employedTime">
          <el-date-picker
            v-model="formMortgagee.employedTime"
            value-format="yyyy-MM-dd"
            type="date"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择入职日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="人员状态：" prop="status">
          <el-select
            v-model="formMortgagee.status"
            :size="size"
            :disabled="disabled"
            clearable
            placeholder="请选择人员状态"
          >
            <el-option label="在岗" :value="1"></el-option>
            <el-option label="已离职" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="人员图像：" prop="photo">
          <UploadPhoto :file-list.sync="formMortgagee.photo" :disabled="disabled">
            <template #info>
                <span>仅支持jpg格式文件</span>
            </template>
          </UploadPhoto>
        </el-form-item>
        <el-form-item label="是否下发：" prop="syncToDevice">
          <el-radio-group v-model="formMortgagee.syncToDevice" :size="size" :disabled="disabled">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="建登录账号：" prop="isLogin">
          <el-radio-group
            v-model="formMortgagee.isLogin"
            :size="size"
            :disabled="disabled || disableds"
          >
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" v-if="!disabled">
        <el-button @click="asyncMortgagee = false" :size="size">取 消</el-button>
        <el-button
          class="submit_btn"
          @click="asyncTitle === 1 ? submitInsertForm() : submitUpdateForm()"
          >提 交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog class="prop_dialog" title="人脸识别" :visible.sync="asyncFace" width="35%">
      <el-form
        ref="formFace"
        :model="formFace"
        :rules="rulesFace"
        label-width="auto"
        class="rule_form"
      >
        <el-form-item label="人员图像：" prop="photo">
          <UploadPhoto :file-list.sync="formFace.photo">
            <template #info>
              <span>仅支持jpg格式文件</span>
            </template>
          </UploadPhoto>
        </el-form-item>
        <el-form-item label="是否下发：" prop="syncToDevice">
          <el-radio-group v-model="formFace.syncToDevice">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="2">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncFace = false">取 消</el-button>
        <el-button class="submit_btn" @click="submitInsertFace()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from "../../../../pinia/index";
import { changeSize, throttle, downLoadFile } from "../../../../plugins/public";
import UploadPhoto from "../../../../components/uploadPhoto.vue";
export default {
  name: "MortgageePossession",
  data() {
    const fileMustUpload = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请上传人脸图像"));
      } else if (value.length < 0) {
        callback(new Error("请上传人脸图像"));
      } else {
        this.$refs.formFace.clearValidate("photo");
        callback();
      }
    };
    return {
      size: changeSize(),
      realName: "",
      departId: "",
      departmentData: [], // 部门信息
      posId: "",
      postData: [], // 岗位信息
      status: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      mortgageeList: [], // 列表信息
      asyncTitle: 1, // 弹窗标题 1 添加人员  2 修改人员信息 3 查看详情信息
      asyncMortgagee: false, // 弹窗
      rulesMortgagee: {
        realName: [
          {
            required: true,
            message: "请输入员工姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        idNo: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
        ],
        userType: [
          {
            required: true,
            message: "请选择人员类型",
            trigger: ["blur", "change"],
          },
        ],
        posId: [
          {
            required: true,
            message: "请选择岗位",
            trigger: ["blur", "change"],
          },
        ],
        departId: [
          {
            required: true,
            message: "请选择部门",
            trigger: ["blur", "change"],
          },
        ],
        zzmm: [
          {
            required: true,
            message: "请选择政治面貌",
            trigger: ["blur", "change"],
          },
        ],
        comeFactoryTime: [
          {
            required: true,
            message: "请选择进厂时间",
            trigger: ["blur", "change"],
          },
        ],
        jg: [
          {
            required: true,
            message: "请输入籍贯",
            trigger: "blur",
          },
        ],
        employedTime: [
          {
            required: true,
            message: "请选择入职日期",
            trigger: ["blur", "change"],
          },
        ],
        status: [
          {
            required: true,
            message: "请选择人员状态",
            trigger: ["blur", "change"],
          },
        ],
        photo: [
          {
            required: true,
            message: "请上传人脸信息",
          },
          {
            validator: fileMustUpload,
            trigger: ["change"],
          },
        ],
        syncToDevice: [
          {
            required: true,
            message: "请选择是否下发",
            trigger: "change",
          },
        ],
        isLogin: [
          {
            required: true,
            message: "请选择是否创建登录账号",
            trigger: "change",
          },
        ],
      }, // 表单校验规则
      disabled: false,
      disableds: false,
      formMortgagee: {
        isLogin: 2,
      }, // 表单信息
      teamGroupData: [], // 班组信息
      dictionaryData: [], // 政治面貌
      cityData: [], // 城市信息
      asyncFace: false,
      formFace: {
        photo: [],
      },
      rulesFace: {
        photo: [
          {
            required: true,
            message: "请上传人脸信息",
          },
          {
            validator: fileMustUpload,
            trigger: ["change"],
          },
        ],
        syncToDevice: [
          {
            required: true,
            message: "请选择是否下发",
            trigger: "change",
          },
        ],
      },
    };
  },
  components: {
    UploadPhoto,
  },
  mounted() {
    const that = this;
    // 根据窗口大小动态修改组件尺寸
    window.onresize = () => {
      that.size = changeSize();
    };
    that.getAllCityInfo();
    that.getDepartmentInfo();
    that.getStationData();
    that.getDictionaryData();
    that.searchMortgageeInfo(true);
  },
  methods: {
    // 获取全部地区信息
    async getAllCityInfo() {
      const { data } = await this.$api.System.getAllCityInfo();
      this.cityData = this.disposeCity(data);
    },
    // 获取政治面貌
    async getDictionaryData() {
      const { data } = await this.$api.Dictionary.searchDictionary({
        dictType: "zzmm",
        pageNum: 1,
        pageSize: 10000,
      });
      this.dictionaryData = data.list;
    },
    // 获取岗位信息
    async getStationData() {
      const { data } = await this.$api.Personnerl.GETSTATIONDATA();
      this.postData = data;
    },
    // 获取部门信息
    async getDepartmentInfo() {
      const { data } = await this.$api.Personnerl.GETDEPARTMENTDATA();
      this.departmentData = data;
    },
    // 查询管服人员信息
    searchMortgageeInfo(bol) {
      if (bol) {
        this.pageNum = 1;
      }
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        userType: 1,
        realName: this.realName,
        departId: this.departId,
        posId: this.posId,
        status: this.status,
      };
      this.loading = true;
      this.mortgageeList = [];
      this.$api.Personnerl.SEARCHMORTGAGEELIST(params)
        .then((res) => {
          if (res.success) {
            this.total = res.data.total;
            this.mortgageeList = res.data.list;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 打开添加信息
    propInsert() {
      this.disabled = false;
      this.disableds = false;
      this.asyncTitle = 1;
      this.asyncMortgagee = true;
    },
    // 打开修改信息
    propUpdate(row) {
      this.disabled = false;
      this.asyncTitle = 2;
      this.asyncMortgagee = true;
      this.setFormData(row);
    },
    // 打开详情信息
    propDetails(row) {
      this.disabled = true;
      this.asyncTitle = 3;
      this.asyncMortgagee = true;
      this.setFormData(row);
    },
    // 打开添加人脸识别
    propInsertFace(row) {
      this.asyncFace = true;
      this.$set(this.formFace, "userId", row.userId);
      if (row.photo) {
        this.$set(this.formFace, "photo", [
          {
            id: 1,
            url: `https://htpipe.thhy-tj.com/${row.photo}`,
            name: row.photo,
            nameImg: row.realName,
          },
        ]);
        this.$set(this.formFace, "syncToDevice", row.syncToDevice);
      }
    },
    // 导出Excel
    exportExcel() {
      this.$api.System.GETEXPORTTOKENDATA({
        userType: 1,
        realName: this.realName,
        departId: this.departId,
        posId: this.posId,
        status: this.status,
      }).then((res) => {
        if (res.success) {
          downLoadFile(res.data, "/staff/platUser/export");
        }
      });
    },
    // 删除人员信息
    deleteInfo(row) {
      this.$confirm("该操作将删除该人员信息，是否继续删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.Personnerl.DELETEMORTGAGEEINFO({ userId: row.userId }).then((res) => {
            if (res.success) {
              this.searchMortgageeInfo(true);
              this.$message.success("删除成功！");
            } else {
              this.$message.warning(res.statusMsg);
            }
          });
        })
        .catch(() => {
          this.$message.warning("您已取消");
        });
    },
    // 提交添加信息
    submitInsertForm: throttle(function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.formMortgagee);
          params.userType = 1;
          params.groups = params.groups ? params.groups.join(",") : "";
          // params.photo =  params.photo.length > 0 ? params.photo[0].name : '';
          this.$api.Personnerl.INSERTMORTGAGEEINFO(params).then((res) => {
            if (res.success) {
              this.asyncMortgagee = false;
              this.searchMortgageeInfo(true);
              this.$message.success("添加成功！");
            } else {
              this.$message.warning(res.statusMsg);
            }
          });
        }
      });
    }, 3000),
    // 提交修改信息
    submitUpdateForm: throttle(function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.formMortgagee);
          params.userType = 1;
          params.groups = params.groups ? params.groups.join(",") : "";
          // params.photo =  params.photo.length > 0 ? params.photo[0].name : '';
          this.$api.Personnerl.UPDATEMORTGAGEEINFO(params).then((res) => {
            if (res.success) {
              this.asyncMortgagee = false;
              this.searchMortgageeInfo(true);
              this.$message.success("修改成功！");
            } else {
              this.$message.warning(res.statusMsg);
            }
          });
        }
      });
    }, 3000),
    // 提交人脸识别添加
    submitInsertFace: throttle(function () {
      this.$refs.formFace.validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.formFace);
          params.photo = params.photo.length > 0 ? params.photo[0].name : "";
          this.$api.Personnerl.insertFaceInfo(params).then((res) => {
            if (res.success) {
              this.asyncFace = false;
              this.searchMortgageeInfo(true);
              this.$message.success("添加人脸成功！");
            } else {
              this.$message.warning(res.statusMsg);
            }
          });
        }
      });
    }, 3000),
    // 选择部门获取班组信息
    changeDepartment(value) {
      if (value) {
        const data = this.departmentData.find((item) => item.departId === value);
        this.teamGroupData = data.groups;
      } else {
        this.teamGroupData = [];
        this.$set(this.formMortgagee, "groups", "");
      }
    },
    // 处理城市信息
    disposeCity(list) {
      const data = list.map((item) => {
        if (item.childs) {
          item.childs = item.childs.map((element) => {
            return {
              id: element.id,
              name: element.name,
            };
          });
        }
        return item;
      });
      return data;
    },
    // 切换页数
    changePageNum(page) {
      this.pageNum = page;
      this.searchMortgageeInfo();
    },
    // 切换每页条数
    changePageSize(size) {
      this.pageSize = size;
      this.searchMortgageeInfo();
    },
    // 判断按钮权限信息
    showButton(str) {
      const pinia = buttonPinia();
      return pinia.$state.buttonInfo.includes(str);
    },
    // 回填表单信息
    setFormData(data) {
      const object = this.departmentData.find((item) => item.departId === data.departId);
      this.teamGroupData = object ? object.groups : [];
      this.$set(this.formMortgagee, "userId", data.userId);
      this.$set(this.formMortgagee, "realName", data.realName);
      this.$set(this.formMortgagee, "phone", data.phone);
      this.$set(this.formMortgagee, "sex", data.sex);
      this.$set(this.formMortgagee, "idNo", data.idNo);
      this.$set(this.formMortgagee, "hasCert", data.hasCert);
      this.$set(this.formMortgagee, "zzmm", data.zzmm);
      this.$set(this.formMortgagee, "employedTime", data.employedTime);
      this.$set(this.formMortgagee, "comeFactoryTime", data.comeFactoryTime);
      this.$set(this.formMortgagee, "leaveFactoryTime", data.leaveFactoryTime);
      this.$set(this.formMortgagee, "jg", Number(data.jgs));
      this.$set(this.formMortgagee, "status", data.status);
      this.$set(this.formMortgagee, "posId", data.posId);
      this.$set(this.formMortgagee, "departId", data.departId);
      this.$set(
        this.formMortgagee,
        "groups",
        data.groupIds ? data.groupIds.split(",") : []
      );
      this.$set(this.formMortgagee, "isLogin", data.isLogin);
      if (data.isLogin == 1) {
        this.disableds = true;
      } else {
        this.disableds = false;
      }
    },
  },
  watch: {
    asyncMortgagee(bol) {
      if (!bol) {
        this.formMortgagee = {};
        this.$set(this.formMortgagee, "isLogin", 2);
        this.$refs.form.resetFields();
      }
    },
    asyncFace(bol) {
      if (!bol) {
        this.formFace = {};
        this.$set(this.formFace, "photo", []);
        this.$refs.formFace.resetFields();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/layout-main.scss";

::v-deep .el-radio {
  padding: 8px 0;
}
</style>
